export default __webpack_public_path__ + "static/media/ethereum-disable.14a10bea.svg";